import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { SmoothScroll } from "./components/SmoothScroll";
import { PersonalNav } from "./components/PersonalNav";
import { PersonalHero } from "./components/PersonalHero";
import { WhoIAm } from "./components/WhoIAm";
import { ProjectsGrid } from "./components/ProjectsGrid";
import { ContentCreatorSection } from "./components/ContentCreatorSection";
import { InterestsSection } from "./components/InterestsSection";
import { JourneyTimeline } from "./components/JourneyTimeline";
import { LifeBeyondWork } from "./components/LifeBeyondWork";
import { SpeakingSection } from "./components/SpeakingSection";
import { WritingSection } from "./components/WritingSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { CollaborationSection } from "./components/CollaborationSection";
import { PersonalFooter } from "./components/PersonalFooter";
import { personalData } from "./mock";

const Home = () => {
  return (
    <SmoothScroll>
      <div className="bg-white dark:bg-gray-900 transition-colors duration-300">
        <PersonalNav />
        
        {/* Hero */}
        <PersonalHero data={personalData.hero} />

        {/* Who I Am */}
        <WhoIAm data={personalData.about} />

        {/* Things I've Built */}
        <div id="work">
          <ProjectsGrid projects={personalData.projects} />
        </div>

        {/* Content Creator */}
        <ContentCreatorSection data={personalData.contentCreator} />

        {/* What I'm Curious About */}
        <InterestsSection interests={personalData.interests} />

        {/* My Journey */}
        <JourneyTimeline timeline={personalData.timeline} />

        {/* Life Beyond Work */}
        <LifeBeyondWork data={personalData.lifeBeyondWork} />

        {/* Speaking & Podcasts */}
        <SpeakingSection data={personalData.speaking} />

        {/* Writing */}
        <div id="writing">
          <WritingSection data={personalData.writing} />
        </div>

        {/* Testimonials */}
        <TestimonialsSection testimonials={personalData.testimonials} />

        {/* Collaboration */}
        <CollaborationSection data={personalData.collaboration} />

        {/* Footer */}
        <PersonalFooter contact={personalData.contact} />
      </div>
    </SmoothScroll>
  );
};

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
